import React, { useEffect } from "react";
import Uploader from "../UserDashboard/Uploder";
import SideBar from "./SideBar";
import Input from "../UserDashboard/Input";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { updateProfileSchema } from "../UserDashboard/Validation";
import { useDispatch, useSelector } from "react-redux";
import userApi from "../../api/user/user.api";
// import {
//   deleteAccountAction,
//   updateProfileAction,
// } from "../../Redux/Actions/UserAction";
import toast from "react-hot-toast";
import { setUser } from "store/features/userSlice";
import ProcessingBar from "Util/Processingbar";

function UpdateProfile() {
  const [image, setImage] = React.useState(null);
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.user);

  console.log({ user });

  // validate user
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(updateProfileSchema),
  });

  // update user
  const handlerSubmit = async (data) => {
    const updatedData = {
      displayName: data.fullName,
      photo: image || user.photo,
      phone: data.phone,
      bio: data.bio || "",
    };

    console.log({ updatedData });

    try {
      const response = await userApi.updateProfile(updatedData);

      if (response?.data?.success) {
        toast.success(response.data.message || "Profile updated!");
        console.log("Profile updated!", response.data);

        // Update Redux store with new user data
        dispatch(setUser(response.data.user));
      } else {
        toast.error("Failed to update profile.");
        console.error("Update failed:", response);
      }
    } catch (err) {
      toast.error(err.message || "Something went wrong");
      console.error("Error updating profile:", err);
    }
  };

  // delete user
  const handlerDelete = () => {
    window.confirm("All your data will be lost. Are you sure?");
    // &&
    //   dispatch(deleteAccountAction());
  };

  const loading = false;
  const error = false;
  const deleteLoading = false;

  // set user data
  useEffect(() => {
    if (user) {
      setValue("fullName", user?.displayName);
      setValue("email", user?.username);
      setValue(
        "phone",
        user?.phone.match(/^\+?[0-9]{7,15}$/) ? String(user?.phone) : "",
      );
      setImage(user?.photo);
    }
  }, [user, setValue]);

  const updateImages = (newImageUrl) => {
    setImage(newImageUrl);
  };

  return (
    <SideBar>
      <div className="flex flex-col gap-4 text-navy mt-4 lg:mt-0">
        <h2 className="text-xl font-bold">Profile</h2>
        <Uploader refreshFunction={updateImages} />

        <Input
          type="text"
          placeHolder="OnlineShop"
          label="Full Name"
          register={register("fullName")}
          errors={errors.fullName}
          name={"fullName"}
        />
        <div className="grid sm:grid-cols-2 gap-4">
          <Input
            type="email"
            placeHolder="user@gmail.com"
            label="Email"
            register={register("email")}
            errors={errors.email}
            name="email"
            readOnly
            verified={user?.isVerified}
          />
          <Input
            type="number"
            placeHolder="Enter your phone number"
            label="Phone Number"
            register={register("phone")}
            errors={errors.phone}
            name={"phone"}
          />
        </div>
        <div className="flex gap-2 flex-wrap flex-col-reverse sm:flex-row justify-between items-center my-4">
          <button
            disabled={deleteLoading || loading}
            onClick={handlerDelete}
            className="bg-navy font-bold rounded-lg sm:w-auto w-full min-w-[180px] min-h-[50px]"
          >
            {deleteLoading ? (
              <ProcessingBar />
            ) : (
              <span className="text-neonYellow animate-neonFlicker ">
                Delete Account{" "}
              </span>
            )}
          </button>
          <button
            disabled={loading || deleteLoading}
            onClick={handleSubmit(handlerSubmit)}
            className="bg-navy font-bold rounded-lg sm:w-auto w-full min-w-[180px] min-h-[50px]"
          >
            {loading ? (
              <ProcessingBar />
            ) : (
              <span className="text-neonYellow animate-neonFlicker ">
                Update Profile
              </span>
            )}
          </button>
        </div>
      </div>
    </SideBar>
  );
}

export default UpdateProfile;
